import { LazyAction, LazyModule } from 'owa-bundling';
import type { OcsWin32MigrationData } from './ocsTypes';

export type { OcsWin32MigrationData } from './ocsTypes';
export { default as getMigrationSettingsUserInput } from './selectors/getMigrationSettingsUserInput';
export { MigrationSettingsDataType } from './store/schema/migrationSettingsData';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "SettingsMigrations"*/ './lazyIndex')
);

export const lazyLaunchMigrationSettingsDialog = new LazyAction(
    lazyModule,
    m => m.launchMigrationSettingsDialog
);

export const lazyOnClickLaunchSettingsMigrationDialog = new LazyAction(
    lazyModule,
    m => m.onClickLaunchSettingsMigrationDialog
);

// If anyone wants the lazy action for these functions, here they are.
export const lazySetWin32UserMigrationState = new LazyAction(
    lazyModule,
    m => m.setWin32UserMigrationState
);
export const lazyIsWin32RecentlyMigratedUser = new LazyAction(
    lazyModule,
    m => m.isWin32RecentlyMigratedUser
);

// But here are convenience wrappers that move the lazy load inside the promise chain.
export function setWin32UserMigrationState(migrationData: OcsWin32MigrationData) {
    return lazySetWin32UserMigrationState.importAndExecute(migrationData);
}
export function isWin32RecentlyMigratedUser(daysToQualifyAsRecentlyMigrated: number) {
    return lazyIsWin32RecentlyMigratedUser.importAndExecute(daysToQualifyAsRecentlyMigrated);
}
